
import { mapGetters } from 'vuex';
export default {
	components: {
		breadcrumbs: () => import('../../components/pages/breadcrumbs.vue'),
	},
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang: 'getterStoreLang'
        })
    }
};
